import React, { useState, useEffect } from 'react';
import { Box, Stack, Paper, Typography, Table, TableBody, TableContainer, TableHead, TableRow, Button, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import { AccordionSummary, AccordionDetails, Accordion } from '../shared/components/accordion';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import PatientFamilyForm from './patientFamilyForm';
import ConfirmDialog from '../shared/components/confirmDialog';
import { FormMode } from '../utils/extensions/constantEx'

const PatientFamilyView = (props) => {
    const { expanded, formOpenMode, patientFamilies, handleAccordionChange, handleServiceFamiliesChange } = props;

    const [isOpenFamilyForm, setIsOpenFamilyForm] = useState(false);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
    const [selectedFamily, setSelectedFamily] = useState(null);

    const handleAddClick = () => {
        setSelectedFamily(null);
        setIsOpenFamilyForm(true);
    }

    const handleSaveClick = (patientFamilyData) => {
        const tempPatientFamilies = [...patientFamilies];

        if (patientFamilyData.id === 0) {
            const tempNextId = 0 - (tempPatientFamilies.length + 1);
            tempPatientFamilies.push({ ...patientFamilyData, id: tempNextId });
        }
        else {
            const tempSelectedDatas = tempPatientFamilies.filter(col => col.id === patientFamilyData.id);
            if (tempSelectedDatas.length > 0) {
                tempSelectedDatas[0].name = patientFamilyData.name;
                tempSelectedDatas[0].relation = patientFamilyData.relation;
                tempSelectedDatas[0].phoneNo = patientFamilyData.phoneNo;
            }
        }
        handleServiceFamiliesChange([...tempPatientFamilies]);
        setIsOpenFamilyForm(false);
    }

    const handleCancelClick = () => {
        setIsOpenFamilyForm(false);
        setSelectedFamily(null);
    }

    const handleDeleteClick = (family) => {
        setIsDeleteConfirmOpen(true);
        setSelectedFamily(family);
    }

    const handleDeleteCancelClick = () => {
        setIsDeleteConfirmOpen(false);
        setSelectedFamily(null);
    }

    const handleDeleteOKClick = () => {
        setIsDeleteConfirmOpen(false);
        const tempPatientFamilies = [...patientFamilies];

        handleServiceFamiliesChange([...tempPatientFamilies.filter(col => col.id !== selectedFamily.id)]);
        setSelectedFamily(null);
    }

    const handleEditClick = (family) => {
        setSelectedFamily(family);
        setIsOpenFamilyForm(true);
    }

    return (

        <Accordion expanded={expanded === 'panelFamily'} onChange={handleAccordionChange('panelFamily')}>
            <AccordionSummary id="panel-pattient-families">
                <Typography>Patient Families and Contacts</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack spacing={1}>
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Box sx={{ pr: 1, float: 'right' }}>
                                <Stack direction="row" spacing={2}>
                                    {
                                        isDeleteConfirmOpen &&
                                        <ConfirmDialog isOpen={isDeleteConfirmOpen} title="Confirm Remove"
                                            message="Are you sure you want to remove the family details?"
                                            handleClickOK={handleDeleteOKClick}
                                            handleClickCancel={handleDeleteCancelClick} />

                                    }
                                    {
                                        isOpenFamilyForm &&
                                        <PatientFamilyForm isOpen={isOpenFamilyForm} selectedFamily={selectedFamily}
                                            handleSaveClick={handleSaveClick}
                                            handleCancelClick={handleCancelClick} />
                                    }
                                    {
                                        formOpenMode !== FormMode.ViewMode &&
                                        <Button variant="contained" onClick={handleAddClick}>Add</Button>
                                    }
                                </Stack>
                            </Box>
                        </Grid>
                        <Grid size={12}>
                            <TableContainer component={Paper} sx={{ maxHeight: '77vh' }}>
                                <Table stickyHeader sx={{ minWidth: 700 }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Name</StyledTableCell>
                                            <StyledTableCell>Relation</StyledTableCell>
                                            <StyledTableCell>Phone No</StyledTableCell>
                                            <StyledTableCell sx={{ width: '90px' }}>&nbsp;</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {patientFamilies.map((row) => (
                                            <StyledTableRow key={row.id}>
                                                <StyledTableCell component="th" scope="row">
                                                    {row.name}
                                                </StyledTableCell>
                                                <StyledTableCell>{row.relation}</StyledTableCell>
                                                <StyledTableCell>{row.phoneNo}</StyledTableCell>
                                                <StyledTableCell>
                                                    {
                                                        formOpenMode !== FormMode.ViewMode &&
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            <IconButton size="small" onClick={() => handleEditClick(row)}>
                                                                <EditIcon fontSize="inherit" />
                                                            </IconButton>
                                                            <IconButton size="small" onClick={() => handleDeleteClick(row)}>
                                                                <RemoveCircleOutlineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Stack>
                                                    }
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Stack>
            </AccordionDetails>
        </Accordion>

    );
}
export default PatientFamilyView;